import React  from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BoxDesign from './BoxDesign';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { langDateChange } from '../Inputs/DateInputWTitle';
import { LoadingColor } from '../LoadingColor';
import { formatPrice } from '../Functions/Price';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconHotels } from '../../Assets/panels/IconHotels';
import { IconNight } from '../../Assets/panels/IconNight';
import { IconReserve } from '../../Assets/panels/IconReserve';
import { IconStar } from '../../Assets/panels/IconStar';
import { TextBtn2 } from '../Inputs/TextBtn2';
const Styles = styled.div`
    width: 100%;
    .over-route {
        margin: 0 1rem 1rem;
        padding: 1.25rem;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .title-part {
            color: var(--text-h);
            display: flex;
            align-items: center;
            gap: 1rem;
            &.active {
                color: var(--main-color);
                .icon {
                    fill: var(--main-color);
                }
            }
            &.inside {
                color: #000000;
                .icon {
                    fill: var(--n-grey-2);
                }
            }
            .icon {
                fill: var(--text-h);
                width: 48px;
                height: 48px;
                display: block;
            }
            .text {
                font-weight: 700;
                font-size: 1.25rem;
            }
        }
        .line {
            height: 1px;
            background-color: var(--n-grey-1);
        }
        .box-hotel {
            display: flex;
            gap: 1rem;
            align-items: center;
            .image {
                width: 30%;
                max-width: 350px;
                aspect-ratio: 1.8;
                background-color: #6ABBAB;
                border: 1px solid var(--n-grey-1);
                border-radius: var(--border-radius-3);
                overflow: hidden;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .line-h {
                align-self: normal;
                width: 1px;
                background-color: var(--n-grey-11);
                color: #FFFFFF00;
            }
            .data {
                width: calc(70%);
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
                flex-grow: 1;
                &.small-gap {
                    gap: 0.75rem;
                }
                .title {
                    font-size: 1.5rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    svg {
                        fill: var(--main-color);
                        width: 48px;
                        height: 48px;
                        display: block;
                    }
                }
                .detail {
                    font-size: 1.25rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    svg {
                        fill: var(--n-grey-2);
                        width: 32px;
                        height: 32px;
                        display: block;
                    }
                }
                .stars {
                    font-size: 1rem;
                    font-weight: 500;
                    color: var(--n-grey-2);
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    svg {
                        fill: var(--n-grey-2);
                        &.active {
                            fill: #FCCA3D;
                        }
                    }
                }
            }
        }
        .prices {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            .line-h {
                width: 1px;
                background-color: var(--n-grey-1);
            }
            .price-item{
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                gap: 0.25rem;
                .title {
                    font-size: 1.2rem;
                    font-weight: 700;
                    padding: 0.5rem;
                }
                .value {
                    font-size: 1rem;
                    font-weight: 700;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .over-route  {
            .box-hotel {
                .image {
                    width: 40%;
                    aspect-ratio: 1;
                }
                .data {
                    .title {
                        gap: 0.5rem;
                        svg {
                            width: 32px;
                            height: 32px;
                        }
                        font-size: 1.1rem;
                    }
                    .stars {
                        font-size: 0.75rem;
                        gap: 0.25rem;
                        svg {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
            }
        }
    }
`
const StyledLink = styled(Link)`
  text-decoration: none;
  color: #000;
  font-weight: bold;
  padding: 0.5rem 0;
  display: inline-block;
  background-color: #fff;
  transition: all 0.3s ease;
  &:hover {
    color:var(--c-main);
  }
`;

export default function TourDetailsHotelsCartV2 ({loading = true, data, lang, ...props}){
    const navigate = useNavigate();
    const makeStars = (num) => {
        let stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <IconStar className={((i < num) ? "active" : "")}/>
            );
        }
        return <div>{stars}</div>
    }
    const makePrices = (prices={}, bundle) => {
        let priceMap = [
            {
                name: DictioneryPanel.packagesDict.Single[lang],
                field: "Tour_hotel_Single_Room_Price",
            },
            {
                name: DictioneryPanel.packagesDict.Double[lang],
                field: "Tour_hotel_Double_Room_Price",
            },
            {
                name: DictioneryPanel.packagesDict.Chiled_With_Bed[lang],
                field: "Tour_hotel_Chiled_With_Bed_Price",
            },
            {
                name: DictioneryPanel.packagesDict.Chiled_Without_Bed[lang],
                field: "Tour_hotel_Chiled_Without_Bed_Price",
            },
            {
                name: DictioneryPanel.packagesDict.Baby[lang],
                field: "Tour_hotel_Baby_Price",
            }
        ];
        priceMap = priceMap.map((v) => {
            let price = [];
            if(prices[v.field + "1"] && prices.Currency_Name1){
                price.push(
                    <div className='value' key={1}>
                        {formatPrice(prices[v.field + "1"]) + " " + prices.Currency_Name1}
                    </div>
                );
            }
            if(prices[v.field + "2"] && prices.Currency_Name2){
                price .push(
                    <div className='value' key={2}>
                        {" + " + formatPrice(prices[v.field + "2"]) + " " + prices.Currency_Name2}
                    </div>
                );
            }
            
            return {
                ...v,
                price: price
            }
        })
        return (
            <div className='prices'>
                {
                    priceMap.map((v, i) => {
                        return (
                            <>
                            <div className='price-item' key={i}>
                                <div className='title'>
                                    {v.name}
                                </div>
                                {v.price}
                            </div>
                            <div className='line-h' key={i+"h"}></div>
                            </>
                        )
                    })
                }
                {
                    (props.noBuy) ? "" : (
                        <div className='price-item'>
                            {
                                (!props.user.API_TOKEN) ? (
                                    <TextBtn2
                                    text={DictioneryPanel.packagesDict.buy[lang]}
                                    onclick={() => {
                                        props.openLoginDialog(() => {
                                            navigate("/" + lang + "/buy-tour/" + data.Tour_Id + "?Tour_Bundle_Id=" + bundle.Tour_Bundle_Id)
                                        })
                                    }}
                                    newType={4}
                                    />
                                ) : (
                                    <TextBtn2
                                        text={DictioneryPanel.packagesDict.buy[lang]}
                                        link={"/" + lang + "/buy-tour/" + data.Tour_Id + "?Tour_Bundle_Id=" + bundle.Tour_Bundle_Id}
                                        newType={4}
                                    />
                                )
                            }
                        </div>
                    )
                }
                
            </div>
        )
    }
    const makeBundles = () => {
        let details = data.HOTEL_BUNDLE ? data.HOTEL_BUNDLE : [];
        return details.map((bundle, bundleI) => {
            let prices = bundle.HOTEL_PRICE.length ? bundle.HOTEL_PRICE[0] : {};
            return (
                <BoxDesign className='over-route' key={bundleI + "b"}>
                    {
                        bundle.HOTEL.map((v, j) => {
                            let i = v.index;
                            let desc = "";
                            if(lang === "fa" && v.Hotel_Desc){
                                desc = v.Hotel_Desc
                            } else if(v.Hotel_En_Desc){
                                desc = v.Hotel_En_Desc
                            }
                            if(desc.length > 250){
                                desc = desc.slice(0, 250);
                                desc = desc + " ..."
                            }
                            return (
                                <>
                                <div className='box-hotel' key={i + "b"}>
                                    <div className='image'>
                                        <img src={v.Hotel_Logo} alt={v.Hotel_Name}/>
                                    </div>
                                    <div className='data small-gap'>
                                        <div className='title'>
                                            <IconHotels/>
                                            {lang === "fa" ? v.Hotel_Name : v.Hotel_En_Name}
                                        </div>
                                        <div className='stars'>
                                            {DictioneryPanel.packagesDict.hotelStar[lang]}: {makeStars(v.Hotel_Star)}
                                        </div>
                                        <div className='stars'>
                                            {DictioneryPanel.packagesDict.service[lang]}: {lang === "fa" ? v.Service_Name : v.Service_EnName}
                                        </div>
                                        <div className='desc'>
                                            {desc}
                                        </div>
                                        <div className='desc'>
                                            {DictioneryPanel.reportsDict.address[lang]}: {lang === "fa" ? v.Hotel_Address : v.Hotel_En_Address}
                                        </div>
                                        <div className='desc'>
                                            {DictioneryPanel.reportsDict.Callnumber[lang]}: {v.Hotel_Tel_No}
                                        </div>
                                        <StyledLink
                                            to={`/${lang}/hotels/${v.Continent_Url}/${v.Country_Url}/${v.City_Url}/${v.Hotel_Url}`}
                                        >
                                            {DictioneryPanel.accessDict.show[lang]}
                                        </StyledLink>
                                    </div>
                                </div>
                                <div className='line'></div>
                                </>
                            )
                        })
                    }
                    {makePrices(prices, bundle)}
                </BoxDesign>
            )
        })
    }
    if(loading){
        return (
            <Styles>
                <LoadingColor/>
            </Styles>
        )
    }
    return (
        <Styles>
            {makeBundles()}
        </Styles>
    )
}